import { authDomain, domainKey } from './constants';

// login
export const authRequested = authDomain.createEvent({
  name: `${domainKey}/events/authRequested`,
  sid: `${domainKey}/events/authRequested`
});
export const authSuccessful = authDomain.createEvent<IUser>({
  name: `${domainKey}/events/authSuccessful`,
  sid: `${domainKey}/events/authSuccessful`
});
export const authFailed = authDomain.createEvent<IFeError>({
  name: `${domainKey}/events/authFailed`,
  sid: `${domainKey}/events/authSuccessful`
});

// signout
export const userSignout = authDomain.createEvent({
  name: `${domainKey}/events/userSignedOut`,
  sid: `${domainKey}/events/userSignedOut`
});
export const userSignoutSuccessful = authDomain.createEvent({
  name: `${domainKey}/events/userSignedOutSuccessful`,
  sid: `${domainKey}/events/userSignedOutSuccessful`
});
export const userSignoutFailed = authDomain.createEvent({
  name: `${domainKey}/events/userSignedOutFailed`,
  sid: `${domainKey}/events/userSignedOutFailed`
});

// error
export const handleError = authDomain.createEvent<IFeError>({
  name: `${domainKey}/events/handleError`,
  sid: `${domainKey}/events/handleError`
});
